import { Box, Card, CardActionArea, SvgIconTypeMap } from "@mui/material";
import theme from "theme";
import { P } from "theme/typography";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface ManagementCardProps {
  onClick: () => void;
  title: string;
  Icon: OverridableComponent<SvgIconTypeMap<Record<string, unknown>, "svg">>;
  color: string;
  id: string;
}
export const ManagementCard = ({ onClick, title, Icon, color, id }: ManagementCardProps) => {
  return (
    <Card id={id} sx={{ backgroundColor: "transparent", height: 156, border: `1px solid ${theme.palette.grey[100]}` }}>
      <CardActionArea
        onClick={onClick}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 156 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Box
            sx={{
              height: 40,
              width: 40,
              backgroundColor: color,
              borderRadius: "8px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}>
            <Icon sx={{ fontSize: 24, color: "#fff" }} />
          </Box>
          <P variant="body2">{title}</P>
        </Box>
      </CardActionArea>
    </Card>
  );
};
